module.exports = __webpack_public_path__ + "static/media/rd_logo_small.4420e611.png";